import { render } from "./TicketEsperado.vue?vue&type=template&id=63bd6c5b"
import script from "./TicketEsperado.vue?vue&type=script&lang=js"
export * from "./TicketEsperado.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__